import React from 'react';

function RotationPrompt({ onDismiss }) {
  return (
    <div className="rotation-suggestion">
      <button className="dismiss-rotation" onClick={onDismiss}>
        ✕
      </button>
      <div className="rotation-content">
        <div className="rotation-icon">📱 ↻</div>
        <p>Rotate to landscape for the best preview experience</p>
      </div>
    </div>
  );
}

export default RotationPrompt;
